export default {"src":"/_next/static/media/linked-in.6cdda7eb.svg","height":256,"width":256};